import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { GlobalModule } from '@app/core/global.module';
import { FuiTooltipDirective } from '@fui/fui-components';
import { AeSelectComponent } from './ae-select/ae-select.component';
import { AngularEditorToolbarComponent } from './angular-editor-toolbar.component';
import { AngularEditorComponent } from './angular-editor.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        GlobalModule,
        FuiTooltipDirective,
    ],
    declarations: [AngularEditorComponent, AngularEditorToolbarComponent, AeSelectComponent],
    exports: [AngularEditorComponent, AngularEditorToolbarComponent],
})
export class AngularEditorModule {}
